export default {
    baseStyle: {
        filledTrack: {
            bg: 'blue'
        }
    }
}
